export const drawClientHeader = (doc, client) => {

  const startX = 14;
  const startY = 12;

  // ======================
  // LOGO (smaller + centered)
  // ======================
  if (client?.logo) {
    doc.addImage(
      client.logo,
      "PNG",
      startX,
      startY + 2,
      20,
      20
    );
  }

  // ======================
  // COMPANY NAME
  // ======================
  doc.setFontSize(15);
  doc.setFont(undefined, "bold");
  doc.text(client?.name || "", startX + 25, startY + 6);

  // ======================
  // ADDRESS
  // ======================
  doc.setFontSize(9);
  doc.setFont(undefined, "normal");

  const addressLines = [
    `${client?.address || ""} ${client?.street2 || ""}`,
    `${client?.city || ""}, ${client?.state || ""} - ${client?.zipcode || ""}`
  ];

  doc.text(addressLines, startX + 25, startY + 10);

// GST + CATEGORY
doc.text(
  `GSTIN: ${client?.gstin || ""}`,
  startX + 25,
  startY + 18
);

// PAN
doc.text(
  `PAN No: ${client?.pan || ""}`,
  startX + 25,
  startY + 22
);
  // ======================
  // RIGHT SIDE CONTACT
  // ======================
  const rightX = 225;

  doc.text(`Phone: ${client?.phone || ""}`, rightX, startY + 12);
  doc.text(`Email: ${client?.email || ""}`, rightX, startY + 16);
  doc.text(`URL: ${client?.website_url || ""}`, rightX, startY + 20);

  // ======================
  // SEPARATOR LINE
  // ======================
  doc.line(14, startY + 34, 285, startY + 34);

  return startY + 38;
};
